export default {
  localNoticeStatus:{
    1:'核销完成',
    7:'订单完成',
    8:'订单退单',
    9:'核销码退款',
    10:'用户核销',
    11:'发码成功'
  },
  mahuaNoticeStatus:{
    1:'已出餐',
    3:'取餐码',
    4:'已接单',
    5:'配送中',
    7:'已完成',
    8:'退单',
  },
  postStatus: {
    draft: '草稿',
    published: '发布',
    recycled: "垃圾"
  },
  /** 前端分类影藏id */
  hiden_category_id: 'ff8080817b2bd737017b2ebeedfb0916',
  // hiden_category_id: 'ff8080817ce5f862017d041e726d008a',

  postType: {
    AR: 'AR资讯',
    HEALTH: '健康资讯',
  },
  sex: {
    male: '男',
    female: '女',
    unknown: '未知'
  },
  couponExamineStatus:{
    None: { type: 'info', name: '未开通' },
    Checking: { type: 'info', name: '审核中' },
    Success: { type: 'success', name: '审核成功' },
    Fail: { type: 'danger', name: '审核失败' },
  },
  examineStatus:{
    None: { type: 'info', name: '审核中' },
    Success: { type: 'success', name: '已退款' },
    Completed: { type: 'success', name: '已退款' },
    Fail: { type: 'danger', name: '审核失败' },
  },
  tiketOrderStatus: {
    None: { type: 'info', name: '未付款' },
    Payed: { type: 'warning', name: '待充值' },
    Delivered: { type: 'success', name: '已充值' },
    Completed: { type: 'success', name: '已完成' },
    Refunded: { type: 'danger', name: '已退单' },
    Cancel: { type: 'danger', name: '已取消' },
    Fail: { type: 'danger', name: '失败' },
  },
  localOrderStatus: {
    None: { type: 'info', name: '发码中' },
    Payed: { type: 'warning', name: '已支付' },
    Delivered: { type: 'success', name: '已核销' },
    Completed: { type: 'success', name: '已完成' },
    Cancel: { type: 'danger', name: '已取消' },
    Fail: { type: 'danger', name: '已退单' },
  },
  localGoodsOrderStatus: {
    None: { type: 'info', name: '待支付' },
    Payed: { type: 'warning', name: '待发货' },
    Delivered: { type: 'success', name: '已发货' },
    Completed: { type: 'success', name: '已完成' },
    Cancel: { type: 'danger', name: '已取消' },
    Fail: { type: 'danger', name: '已退单' },
  },
  localWsOrderStatus: {
    None: { type: 'info', name: '待支付' },
    Payed: { type: 'success', name: '已支付' },
    Delivered: { type: 'success', name: '已支付' },
    Completed: { type: 'success', name: '已完成' },
    Cancel: { type: 'danger', name: '已取消' },
    Fail: { type: 'danger', name: '已退单' },
  },
  mahuaOrderStatus: {
    None: { type: 'info', name: '待付款' },
    Payed: { type: 'warning', name: '出餐中' },
    Delivered: { type: 'success', name: '待取餐' },
    Completed: { type: 'success', name: '已完成' },
    Refunded: { type: 'danger', name: '已退单' },
    Cancel: { type: 'danger', name: '已取消' },
    Fail: { type: 'danger', name: '失败' },
  },
  providerArr: [
    { name: '星星话费', value: 'XingXing' },
    { name: '鲸360', value: 'Jing360' },
    { name: '微点话费', value: 'WeiDian' },
    { name: '橘子优充', value: 'OrangeRecharge' },
    { name: '券码无忧', value: 'Quanma51' },
    { name: '微客云', value: 'Wikeyun' },
    { name: '手动出单', value: 'Handler' },
    { name: '果乔话费', value: 'GuoQiao' },
    { name: '麻花', value: 'Mahua' },
  ],

  goodsTypes: [
    { name: "话费充值", value: "TelephoneCharge" },
    { name: "油卡充值", value: "OilCardCharge" },
    { name: "本地生活", value: "LocalCater" },
    { name: "电商产品", value: "Eshop" },
    { name: "点餐产品", value: "Mahua" },
  ],
}